<template>
  <div
    class="modal fade custom-scrollbar"
    :style="'cursor: url(' + cursorImage() + '), auto !important'"
    :class="[modalSize === 'fullscreen' ? 'border-0 p-0 m-0' : '']"
    :data-backdrop="modalBackdrop ? modalBackdrop : 'static'"
    :data-keyboard="`${modalBackdrop}`"
    :id="modalId"
    tabindex="-1"
    role="dialog" 
    aria-hidden="true"
  >
    <div
      class="modal-dialog "
      :class="[
        modalSize === 'fullscreen' ? 'h-100' : '',
        modalScroll? 'modal-dialog-scrollable':'',
        modalAlignment === 'modal-dialog-centered'
          ? 'modal-dialog-top'
          : 'modal-dialog-centered',
        checkModalSize,
        { 'modalSize': 'full-width' },
      ]"
      role="document"
    >
      <div class="container bg-white p-0"
      v-if="modalSize === 'modalheight'"
        style="height: 80vh !important; overflow-y: auto;">
        <div
          v-if="$slots.header"
          :key="modalId + 'header'"
          class="modal-header"
        >
          <slot name="header"></slot>
        </div>

        <div
          v-if="$slots.body"
          :key="modalId + 'body'"
          class="modal-body custom-scrollbar"
          :class="modalBodyClass"
        >
          <slot name="body"></slot>
        </div>

        <div
          v-if="$slots.footer"
          :key="modalId + 'footer'"
          class="modal-footer"
        >
          <slot name="footer"></slot>
        </div>
        <slot></slot>
      </div>
      <div v-else class="modal-content">
        <div
          v-if="$slots.header"
          :key="modalId + 'header'"
          class="modal-header"
        >
          <slot name="header"></slot>
        </div>

        <div
          v-if="$slots.body"
          :key="modalId + 'body'"
          class="modal-body custom-scrollbar"
          :class="modalBodyClass"
        >
          <slot name="body"></slot>
        </div>

        <div
          v-if="$slots.footer"
          :key="modalId + 'footer'"
          class="modal-footer"
        >
          <slot name="footer"></slot>
        </div>
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
import AppFunction from "../../helpers/app/AppFunction";

export default {
  name: "AppModal",
  props: {
    modalId: {
      type: String,
      required: true,
    },
    modalSize: {
      type: String,
      default: "default",
    },
    modalAlignment: {
      type: String,
      default: "top",
    },
    modalScroll: {
      type: Boolean,
      default: false,
    },
    modalBodyClass: {
      type: String,
    },
    modalBackdrop: {
      type: Boolean,
      default: true,
    },
  },
  mounted() {
    $("#" + this.modalId).on("shown.bs.modal", () => {
      $("html").css("overflow-y", "hidden");
    });

    $("#" + this.modalId).on("hidden.bs.modal", () => {
      if ($(".modal.show").length === 0) {
        $("html").css("overflow-y", "auto");
      }
      this.$emit("close-modal", false);
    });

    $("#" + this.modalId).modal("show");
  },
  beforeDestroy() {
    const $modal = $("#" + this.modalId);
    $modal.off("shown.bs.modal hidden.bs.modal");
    $modal.modal("dispose");
    // Remove orphaned backdrop if no other modals are shown
    if ($(".modal.show").length === 0) {
      $(".modal-backdrop").remove();
      $("body").removeClass("modal-open");
      $("html").css("overflow-y", "auto");
    } else {
      // Keep only one backdrop for the remaining modal
      while ($(".modal-backdrop").length > 1) {
        $(".modal-backdrop").last().remove();
      }
      $("body").addClass("modal-open");
    }
  },
  computed: {
    checkModalSize() {
      if (this.modalSize === "default") return "modal-default";
      else if (this.modalSize === "small") return "modal-sm";
      else if (this.modalSize === "large") return "modal-lg";
      else if (this.modalSize === "extra-large") return "modal-xl";
      else if (this.modalSize === "modalheight") return "modal-xl";
      else if (this.modalSize === "full-width") return "modal-fullwidth";
      else if (this.modalSize === "fullscreen")
        return "full-screen-modal-dialog";
      else return "";
    },
  },
  methods: {
    cursorImage() {
      if (this.$store?.state?.theme?.darkMode) {
        return AppFunction.getAppUrl("images/close-cursor-dark.png");
      } else {
        return AppFunction.getAppUrl("images/close-cursor-light.png");
      }
    },
  },
};
</script>
